import '../../utils/index.mjs';
import _sfc_main from './src/autocomplete2.mjs';
export { autocompleteEmits, autocompleteProps } from './src/autocomplete.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElAutocomplete = withInstall(_sfc_main);

export { ElAutocomplete, ElAutocomplete as default };
//# sourceMappingURL=index.mjs.map
